import React from 'react';
import AgreeCheck from '../../../components/AgreeCheck';
import { StylePageTitle } from '../../../styles/sharedStyleComponets';

interface FeesAndCancellationPolicyProps {
  isAgreedTheFees: boolean;
  isAgreedTheCancelPolicy: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsAgreedTheFees: (isAgreedTheFees: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  setIsAgreedTheCancelPolicy: (isAgreedTheCancelPolicy: boolean) => void;
}

const FeesAndCancellationPolicy = ({
  isAgreedTheFees, isAgreedTheCancelPolicy, setIsAgreedTheFees, setIsAgreedTheCancelPolicy,
}: FeesAndCancellationPolicyProps) => (
  <div style={{ marginTop: '50px' }}>
    <StylePageTitle level={2}>
      Fees and Cancellation Policy
    </StylePageTitle>

    <AgreeCheck
      text={['I have read and accepted the service fee terms and conditions of the Amplar Health Virtual Psychology Clinic; I understand the Amplar Health Virtual Psychology team will collect my card details for payment via eway, a secure payment gateway. I agree to pay the full fee 72 hours prior to our consultation. I consent Amplar Health Virtual Psychology team to use my collected card details for payment of any follow-up consults I book and attend.']}
      isAgreed={isAgreedTheFees}
      setIsAgreed={setIsAgreedTheFees}
    />

    <AgreeCheck
      text={(
        <>
          Our psychologists have reserved time for you. If you must cancel your consultation, we respectfully request 48 hours&apos; notice.
          <br />
          Missed consultations, or consultations cancelled without a valid medical reason within 48 hours of the consultations, will incur a fee equivalent to the full fee of such consultation
        </>
      )}
      isAgreed={isAgreedTheCancelPolicy}
      setIsAgreed={setIsAgreedTheCancelPolicy}
    />
  </div>
);

export default FeesAndCancellationPolicy;
